<template>
    <DeathData/>
</template>

<script>
import { DeathData } from 'shared'

export default {
    name: 'deathData',
    components: {
        DeathData
    },
    created() {
        this.$store.commit('getDeath', {
            shares: '零售电商',
            a100: '社交电商'
        })
    }
}
</script>